<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'ASSOCIATIONS.CAMPAIGNS.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button mat-stroked-button color="primary" class="association-button" (click)="addCampaigns()">
    <mat-icon>add</mat-icon> {{ 'ASSOCIATIONS.CAMPAIGNS.ADD_ASSOCIATION' | translate }}
  </button>
  @for (campaign of campaigns$ | async; track campaign) {
    <mat-card class="card">
      <mat-card-header class="card-header">
        @if (campaign.title) {
          <mat-card-title class="name">
            <a [routerLink]="campaign.link">{{ campaign.title }}</a>
          </mat-card-title>
        }
        @if (campaign.recipientCampaignId) {
          <mat-menu #menu="matMenu">
            @if (campaign.recipientCampaignStatus === CampaignScheduleStatus.CAMPAIGN_SCHEDULE_STATUS_ACTIVE) {
              <button mat-menu-item (click)="pauseCampaign(campaign)">
                {{ 'ASSOCIATIONS.CAMPAIGNS.MENU.PAUSE.PAUSE_CAMPAIGN' | translate }}
              </button>
            } @else if (campaign.recipientCampaignStatus === CampaignScheduleStatus.CAMPAIGN_SCHEDULE_STATUS_STOPPED) {
              <button mat-menu-item (click)="resumeCampaign(campaign)">
                {{ 'ASSOCIATIONS.CAMPAIGNS.MENU.RESUME.RESUME_CAMPAIGN' | translate }}
              </button>
            }
          </mat-menu>
          @if (canShowMenu(campaign.recipientCampaignStatus)) {
            <button mat-icon-button color="primary" [matMenuTriggerFor]="menu" class="menu-button">
              <mat-icon>more_vert</mat-icon>
            </button>
          }
        }
      </mat-card-header>
      <mat-card-content class="content">
        <crm-recipient-campaign-status [recipientCampaignStatus]="campaign.recipientCampaignStatus">
        </crm-recipient-campaign-status>
      </mat-card-content>
    </mat-card>
  }
  @if (canViewAllCampaigns$ | async) {
    <button mat-stroked-button color="primary" class="association-button" (click)="viewAll()">
      {{ 'ASSOCIATIONS.CAMPAIGNS.VIEW_ALL' | translate }}
    </button>
  }
</mat-expansion-panel>
